module.exports = __webpack_public_path__ + "static/mr-press-14-1b10d8f597698fea29dc29c922501717.jpg";